"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createApi = void 0;
var Error_1 = __importDefault(require("./utils/Error"));
var notFoundError = function notFoundError(method) {
  return new Error_1.default({
    message: (method !== null && method !== void 0 ? method : 'unknown method') + ": The resource could not be found."
  });
};
var createApi = function createApi(_a) {
  var http = _a.http,
    options = _a.options;
  var getSites = function getSites(isoCode) {
    return http.get("sites", {
      params: {
        isoCode: isoCode
      }
    }).then(function (response) {
      return response.data;
    });
  };
  var getSite = function getSite(isoCode) {
    return http.get("sites/" + options.siteId, {
      params: {
        isoCode: isoCode
      }
    }).then(function (response) {
      return response.data;
    });
  };
  var getPages = function getPages(isoCode, pageIds) {
    return http.get("sites/" + options.siteId + "/pages", {
      params: {
        isoCode: isoCode,
        pageIds: pageIds
      }
    }).then(function (response) {
      return response.data;
    });
  };
  var getPage = function getPage(id, isoCode) {
    if (id === undefined || id === null) {
      return Promise.reject(notFoundError('getPage'));
    }
    return http.get("sites/" + options.siteId + "/pages/" + id, {
      params: {
        isoCode: isoCode
      }
    }).then(function (response) {
      return response.data;
    });
  };
  var getLinkCollections = function getLinkCollections(isoCode) {
    return http.get("sites/" + options.siteId + "/link-collections", {
      params: {
        isoCode: isoCode
      }
    }).then(function (response) {
      return response.data;
    });
  };
  var getLinkCollection = function getLinkCollection(id, isoCode) {
    if (id === undefined || id === null) {
      return Promise.reject(notFoundError('getLinkCollection'));
    }
    return http.get("sites/" + options.siteId + "/link-collections/" + id, {
      params: {
        isoCode: isoCode
      }
    }).then(function (response) {
      return response.data;
    });
  };
  var getPredefinedEvents = function getPredefinedEvents(isoCode, from, to, order, includePast, includeFuture) {
    return http.get("sites/" + options.siteId + "/predefined-events", {
      params: {
        isoCode: isoCode,
        from: from,
        to: to,
        order: order,
        includePast: includePast,
        includeFuture: includeFuture
      }
    }).then(function (response) {
      return response.data;
    });
  };
  var getPredefinedEventList = function getPredefinedEventList(id, isoCode, from, to, order, includePast, includeFuture) {
    if (id === undefined || id === null) {
      return Promise.reject(notFoundError('getPredefinedEventList'));
    }
    return http.get("sites/" + options.siteId + "/predefined-event-list/" + id, {
      params: {
        isoCode: isoCode,
        from: from,
        to: to,
        order: order,
        includePast: includePast,
        includeFuture: includeFuture
      }
    }).then(function (response) {
      return response.data;
    });
  };
  var getDictionary = function getDictionary(isoCode) {
    var _baseUrl = options.apiUrl + "/api/v1";
    return http.get("dictionary", {
      baseURL: _baseUrl,
      params: {
        isoCode: isoCode
      }
    }).then(function (response) {
      return response.data;
    });
  };
  var getDictionaryItem = function getDictionaryItem(dictionaryKey, isoCode) {
    if (dictionaryKey === undefined || dictionaryKey === null) {
      return Promise.reject(notFoundError('getDictionaryItem'));
    }
    var _baseUrl = options.apiUrl + "/api/v1";
    return http.get("dictionary/" + dictionaryKey, {
      baseURL: _baseUrl,
      params: {
        isoCode: isoCode
      }
    });
  };
  return {
    getSites: getSites,
    getSite: getSite,
    getPages: getPages,
    getPage: getPage,
    getLinkCollections: getLinkCollections,
    getLinkCollection: getLinkCollection,
    getPredefinedEvents: getPredefinedEvents,
    getPredefinedEventList: getPredefinedEventList,
    getDictionary: getDictionary,
    getDictionaryItem: getDictionaryItem
  };
};
exports.createApi = createApi;